import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PlaylistSetupPage from './pages/PlaylistSetupPage';
import './App.css';

function App() {
  return (
    <Router basename="/">
      <div className="App">
        <Routes>
          <Route path="/*" element={<PlaylistSetupPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
